// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1yeY3","label":"CategoryService_label__1Krww","location":"CategoryService_location__23VbZ"};